export const QUIZ_LIMIT_COUNT = 10;
